import {
  RazorInputField,
  RazorNumberFormat,
} from "../../../../components/razor-reuse";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import { EditExchangeRate } from "../../../../redux/settings";
import RootState from "../../../../redux/type";
import {
  capitalizeFirstLetter,
  reactSelectStyleTable,
} from "../../../../utils/Helper";
import { debounce } from "lodash";
import ExchangeCurrencyText from "../../../../components/fragment/cur-text/ExchangeCurrencyText";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  detail?: any;
  onFinish?: () => void;
}

const EditExchangeRateModal = ({
  onClose,
  visible,
  detail,
  onFinish,
}: myComponentProps) => {
  const { loadingDelete } = useSelector((state: RootState) => state.settings);
  const dispatch = useDispatch();

  type detailProps = {
    rate: string;
    base: any;
    desination: any;
    fx_rate: string;
    fx_type: any;
    percentage_mark: string;
    effective_rate: string | number;
    status: boolean;
  };
  const [details, setDetails] = useState<detailProps>({
    rate: "",
    base: "",
    desination: "",
    fx_rate: "",
    fx_type: "",
    percentage_mark: "",
    effective_rate: "",
    status: false,
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  // Custom label component for options with images
  const handleSubmit = async () => {
    const obj = {
      exchange_rate: RazorNumberFormat(details?.rate, {
        convertToNumber: true,
      }),
      destination_currency: details?.desination?.id,
      source_currency: details?.base?.id,
      id: detail?.id,
      fx_type: details?.fx_type?.value,
      status: details?.status ? "active" : "inactive",
      markup_percentage: details?.percentage_mark,
      effective_rate: details?.effective_rate,
      fx_rate: detail?.base_rate,
      provider: detail?.provider,
    };
    
    // return
    const data = await dispatch(EditExchangeRate(obj) as any);

    if (data?.payload?.data?.status) {
      setDetails({
        rate: "",
        base: "",
        desination: "",
        fx_rate: "",
        fx_type: "",
        percentage_mark: "",
        effective_rate: "",
        status: false,
      });
      onFinish && onFinish();
    }
  };

  useEffect(() => {
    if (visible) {
      // console.log(detail);
      const obj = {
        rate: RazorNumberFormat(detail?.rate, {
          convertToNumber: true,
          hideDecimal: true,
        }),
        fx_rate: detail?.base_rate,
        base: {
          ...detail?.source_currency,
          label: detail?.source_currency?.code,
          value: detail?.source_currency?.id,
          imageUrl: detail?.source_currency?.logo,
        },
        desination: {
          ...detail?.destination_currency,
          label: detail?.destination_currency?.code,
          value: detail?.destination_currency?.id,
          imageUrl: detail?.destination_currency?.logo,
        },
        percentage_mark: detail?.markup_percentage?.replace("%", ""),
        effective_rate: detail?.rate,
        status: detail?.status === "inactive" ? false : true,
        fx_type: {
          label: capitalizeFirstLetter(detail?.fx_type),
          value: detail?.fx_type,
        },
      };
      setDetails(obj);
    }
  }, [visible]);

  const formatDropDownOption = () => {
    const objSelectedList = [
      {
        label: `${details?.base?.label} - ${details?.desination?.label}`,
        value: `${details?.base?.value},${details?.desination?.value}`,
        fromLabel: details?.base?.label,
        toLabel: details?.desination?.label,
        imageUrl: ``,
      },
    ];
    return objSelectedList;
  };

  const formatOptionLabelTwo = ({ label, fromLabel, toLabel, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <ExchangeCurrencyText
            // loading={}
            curOne={fromLabel || "NIL"}
            curTwo={toLabel || "NIL"}
            urlOne={
              fromLabel === "USD"
                ? ""
                : fromLabel === "EUR"
                ? ""
                : fromLabel === "GBP"
                ? ""
                : fromLabel === "NGN"
                ? ""
                : fromLabel === "CAD"
                ? ""
                : ""
            }
            urlTwo={
              toLabel === "USD"
                ? ""
                : toLabel === "EUR"
                ? ""
                : toLabel === "GBP"
                ? ""
                : toLabel === "NGN"
                ? ""
                : toLabel === "CAD"
                ? ""
                : ""
            }
          />
        </>
      );
    }
  };

  function isNumberOrDecimalOnly(input: string): boolean {
    // Allow empty string or string with spaces
    if (input.trim() === "") {
      return true;
    }

    // Regular expression to check if the string contains only digits and one optional '.'
    const validCharactersRegex = /^[0-9.]+$/;

    // Ensure only valid characters exist and at most one '.'
    if (!validCharactersRegex.test(input) || input.split(".").length > 2) {
      return false;
    }

    return true;
  }

  const getEffectiverate = debounce(() => {
    // let val;
    if (details?.fx_type?.value === "buy") {
      const mathVal =
        Number(details?.fx_rate) -
        (Number(details?.fx_rate) * Number(details?.percentage_mark)) / 100;
      setDetails((prev) => {
        return {
          ...prev,
          effective_rate: String(mathVal) === "0" ? "0" : mathVal.toFixed(2),
        };
      });
    }
    if (details?.fx_type?.value === "sell") {
      const mathVal =
        Number(details?.fx_rate) +
        (Number(details?.fx_rate) * Number(details?.percentage_mark)) / 100;
      setDetails((prev) => {
        return {
          ...prev,
          effective_rate: String(mathVal) === "0" ? "0" : mathVal.toFixed(2),
        };
      });
    }
  }, 500);

  useEffect(() => {
    if (details?.fx_rate && details?.percentage_mark && details?.fx_type) {
      getEffectiverate();
    }
  }, [details?.percentage_mark, details?.fx_type, details?.fx_rate]);

  const handleClose = () => {
    setDetails({
      rate: "",
      base: "",
      desination: "",
      fx_rate: "",
      fx_type: "",
      percentage_mark: "",
      effective_rate: "",
      status: false,
    });
    onClose?.();
  };

  const selectTypeOption = [
    { label: "Buy", value: "buy" },
    { label: "Sell", value: "sell" },
  ];

  return (
    <>
      <ReuseModal
        title="Update Exchange Rate"
        btnLabel="Update Rate"
        visible={visible}
        onClose={handleClose}
        disable={
          details?.effective_rate === detail?.rate &&
          detail?.markup_percentage?.replace("%", "") ===
            details?.percentage_mark &&
          detail?.fx_type === details?.fx_type?.value
        }
        loading={loadingDelete}
        onBtnClick={handleSubmit}
      >
        <div className="add-exchange-currency-modal-wrap gap-[10px] -mt-[20px]">
          <>
            <RazorInputField
              color="black-light"
              type="select"
              placeholder="Select  Currency Pair"
              label=" Currency Pair"
              disabled
              style={{ position: "relative", zIndex: 3 }}
              selectOption={formatDropDownOption()}
              onChange={(e: any) => {}}
              value={formatDropDownOption()[0]}
              selectStyles={reactSelectStyleTable}
              formatOptionLabel={formatOptionLabelTwo}
              // selectMenuOpen
              // labelSpanText={
              //   details?.fx_rate
              //     ? `1 ${details?.base?.label} ==> ${details?.fx_rate} ${details?.desination?.label}`
              //     : ""
              // }
            />
            <RazorInputField
              disabled
              value={details?.fx_rate}
              color="black-light"
              label="Current FX Rate"
              type={`text`}
              placeholder=" "
            />
            <RazorInputField
              color="black-light"
              type="select"
              placeholder="Select FX Type"
              label="FX Type"
              style={{ position: "relative", zIndex: 2 }}
              // disabled={!details?.base}
              selectOption={selectTypeOption}
              // formatOptionLabel={formatOptionLabel}
              value={details?.fx_type}
              selectStyles={reactSelectStyleTable}
              onChange={(e: any) => {
                setDetails((prev) => {
                  return {
                    ...prev,
                    fx_type: e,
                  };
                });
              }}
            />
            <RazorInputField
              color="black-light"
              type="text"
              placeholder="Set Percentage Mark"
              label="Percentage Mark%"
              style={{ position: "relative", zIndex: 1 }}
              value={details?.percentage_mark}
              onChange={(e: any) => {
                if (
                  isNumberOrDecimalOnly(e.target.value) &&
                  Number(e.target.value) <= 100
                ) {
                  handleChange(e);
                }
                // handleChange(e)
              }}
              name="percentage_mark"
              thousandFormat
              labelSpanText={
                details?.percentage_mark && details?.fx_type?.value === "sell"
                  ? `${details?.percentage_mark}%`
                  : details?.percentage_mark &&
                    details?.fx_type?.value === "buy"
                  ? `-${details?.percentage_mark}%`
                  : ""
              }
            />
            <RazorInputField
              disabled
              value={details?.effective_rate}
              color="black-light"
              label="Effective Rate"
              type={`text`}
              placeholder=" "
            />
            {/* <div className="activate-currency-pair-box">
              <RazorToggleSlide
                color={`black-light`}
                value={details?.status}
                onChange={() => {
                  setDetails((prev) => {
                    return { ...prev, status: !details?.status };
                  });
                }}
              />
              <div className="label">Activate currency pair</div>
            </div> */}
          </>
        </div>
      </ReuseModal>
    </>
  );
};

export default EditExchangeRateModal;
